








































import {
  Component,
  Vue,
  Emit,
  PropSync,
  Watch,
  Prop
} from "vue-property-decorator";
import { namespace } from "vuex-class";

@Component
export default class CreditLimitAjustDialog extends Vue {
  @PropSync("visible", { type: Boolean, default: false })
  dialogVisible: boolean;
  @Prop({
    type: Object,
    default: () => {}
  })
  rowData;
  private isSaveLoading = false;
  form: any = {
    pre: "1000.00",
    total: ""
  };
  get aftervailableNum() {
    let result: any = "";
    let diff = this.rowData.creditDebt || "";
    let num: any = this.form.total;
    let regE: any = /^(0|[1-9]\d*)$/;
    if (num && regE.test(num)) {
      result = Number(num) - Number(diff);
    }
    return result;
  }
  get rules() {
    return {
      total: [
        {
          required: true,
          message: "请输入信用金额度",
          trigger: "blur"
        },
        {
          pattern: /^(0|[1-9]\d*)$/,
          message: "请输入0或者正整数",
          trigger: "blur"
        },
        {
          validator: this.validateTotal,
          trigger: "blur"
        }
      ]
    };
  }

  validateTotal(rule, value, callback) {
    let valNum: any = Number(value);
    let debtNum: any = Number(this.rowData.creditDebt);
    // console.log(valNum, debtNum, valNum < debtNum, "--valNum < debtNum");
    if (valNum < debtNum) {
      let error: any = "额度值不能小于门店欠款";
      callback(new Error(error));
    } else {
      callback();
    }
  }

  @Watch("visible")
  watchVisibleFn(val) {
    if (val) {
      // 初始化弹窗数据
    } else {
      let $form: any = this.$refs.form;
      $form && $form.resetFields();
    }
  }
  created() {
    // 获取导出项配置
  }

  submit() {
    let $form: any = this.$refs.form;
    $form.validate(val => {
      if (val) {
        // this.dialogVisible = false;
        this.$emit("submit", this.form.total);
      }
    });
  }
}
